import router from '@/router'
import { useCommonStore } from '../stores/commonStore'
import type { BusinessLinesInterface } from '../../common/common/models/DXP/BranchesData'
import ServiceError from '@/modules/core/models/errors/ServiceError'
import { ErrorDisplayTypeEnum } from '../models/enums'
import SpanishBranches from '../models/SpanishBranches'
import { useSharedGtmDataStore } from '../stores/sharedGtmDataStore'

export async function checkRecoveredQuotationBranch(
  recoveredBusinessLineId: string,
  currentBranchBusinessLineId: string,
  quotationId: string
): Promise<boolean> {
  const commonStore = useCommonStore()
  if (recoveredBusinessLineId !== currentBranchBusinessLineId) {
    // recovered quotation is not from the current branch
    const branch = Object.keys(commonStore.businessLines!).find(
      (key: string) =>
        commonStore.businessLines![key as keyof BusinessLinesInterface].id ===
        recoveredBusinessLineId
    )
    if (branch) {
      // try to redirect to the correct one
      const path = `/contratacion/${SpanishBranches[branch as keyof typeof SpanishBranches]}/${quotationId}`
      await router.push(path)
      //   window.location.href = window.location.origin + path
    } else {
      // wrong branch error
      await router.push(`/`)
      throw new ServiceError({}).setDisplayType(ErrorDisplayTypeEnum.TOAST)
    }
    return false
  }
  return true
}

export function getBranch() {
  const sharedGtmDataStore = useSharedGtmDataStore()
  return sharedGtmDataStore.ramo
}

export function getBranchMaxAge() {
  const sharedGtmDataStore = useSharedGtmDataStore()
  const text: any = {
    common: 'common',
    salud: 'common',
    dental: 'dental',
    mascotas: 'common'
  }
  const branch = sharedGtmDataStore.ramo?.toString() || 'common'
  return text[branch] || 'common'
}
